import {Tekstbericht} from "./tekstbericht";
import {autoserializeAs, inheritSerialization} from "cerialize";
import * as moment from 'moment';
import { MomentTransformer } from "../helpers/moment-transformer";
import { Palette } from "../helpers/user-color/palette";

@inheritSerialization(Tekstbericht)
export class Chat extends Tekstbericht {
  public static readonly type = 'Chat';

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('user_id')
  public userId: number;

  @autoserializeAs('naam')
  public naam: string;

  @autoserializeAs('bericht')
  public bericht: string;

  @autoserializeAs(MomentTransformer, 'tijd')
  public tijd: moment.Moment;

  public getColor() {
    return Palette.getHSLA(this.userId);
  }
}
